<!-- Modals -->
<!-- Revise offer modal-->
<ui-dialog
    #reviseOfferModal
    header="{{ 'offer-letter.reviseAcceptedOffer' | translate }}"
    (closing)="reviseOfferModal.open = false"
>
    <ng-container *ngIf="offerLetterHasCosigners; else noCosignersCopy">
        <p>{{ 'offer-letter.infoReviseCosigners' | translate }}</p>
        {{ 'offer-letter.infoReviseCosignersActions' | translate }}
        <ul>
            <li>{{ 'offer-letter.infoReviseCosignersAction1' | translate }}</li>
            <li>{{ 'offer-letter.infoReviseCosignersAction2' | translate }}</li>
        </ul>
    </ng-container>
    <ng-template #noCosignersCopy>
        <p>{{ 'offer-letter.infoReviseNoCosigners' | translate }}</p>
    </ng-template>
    <p>{{ 'offer-letter.infoReviseAreYouSure' | translate }}</p>

    <ui-dialog-footer class="margin-top-5">
        <ui-button type="ghost" (click)="reviseOfferModal.open = false">{{
            'offer-letter.cancel' | translate
        }}</ui-button>
        <ui-button type="danger" (click)="onReviseOfferLetter(); reviseOfferModal.open = false">{{
            'offer-letter.revise' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<!-- Modify note modal-->
<ui-dialog #modifyNoteModal [header]="modifyNoteModalTitle" (closing)="modifyNoteModal.open = false">
    <form #modifyNoteModalForm="ngForm" autocomplete="off" class="app-grid">
        <p class="modal-form-padding">{{ 'offer-letter.infoInternalNotes' | translate }}</p>
        <mat-form-field class="columns-12 modal-form-padding">
            <textarea
                maxlength="900"
                matInput
                required
                name="note"
                [(ngModel)]="candidate.note"
                #note="ngModel"
                [rows]="8"
            ></textarea>
            <mat-error *ngIf="note.invalid">{{ note.errors | formErrors }}</mat-error>
            <mat-hint *ngIf="note.value?.length >= 800">{{
                'offer-letter.noteHint' | translate: { x: note.value?.length }
            }}</mat-hint>
        </mat-form-field>
    </form>

    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onCancelNote(); modifyNoteModal.open = false">{{
            'offer-letter.cancel' | translate
        }}</ui-button>
        <ui-button type="primary" (click)="onModifyNote(); modifyNoteModal.open = false">{{
            'offer-letter.save' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<!-- Withdraw Offer Modal -->
<ui-dialog
    header="{{ 'offer-letter.withdrawOffer' | translate }}"
    confirmationDialog
    [open]="openWithdrawOfferModal"
    [primaryButtonLabel]="'offer-letter.withdraw' | translate"
    [primaryButtonType]="'danger'"
    (primaryButtonPressed)="onWithdrawOfferLetter(); openWithdrawOfferModal = false"
    [secondaryButtonLabel]="'offer-letter.cancel' | translate"
    [secondaryButtonType]="'ghost'"
    (secondaryButtonPressed)="openWithdrawOfferModal = false"
    (closing)="openWithdrawOfferModal = false"
>
    <p>{{ 'offer-letter.infoWithdrawOffer' | translate }}</p>
</ui-dialog>

<!-- Candidate Declined Modal -->
<ui-dialog
    header="{{ 'offer-letter.candidateDeclined' | translate }}"
    confirmationDialog
    [open]="openCandidateDeclinedModal"
    (primaryButtonPressed)="onDecline(); openCandidateDeclinedModal = false"
    [secondaryButtonType]="'ghost'"
    (secondaryButtonPressed)="openCandidateDeclinedModal = false"
    (closing)="openCandidateDeclinedModal = false"
>
    <p>{{ 'offer-letter.infoCandidateDeclined' | translate }}</p>
</ui-dialog>

<!-- Delete candidate modal-->
<ui-dialog
    header="{{ 'offer-letter.deleteCandidate' | translate }}"
    deleteDialog
    [open]="openDeleteCandidateModal"
    (closing)="openDeleteCandidateModal = false"
    (primaryButtonPressed)="onDeleteCandidate(); openDeleteCandidateModal = false"
    (secondaryButtonPressed)="openDeleteCandidateModal = false"
>
    <p>{{ 'offer-letter.infoDeleteCandidate' | translate }}</p>
</ui-dialog>

<!-- Hire candidate warning modal-->
<ui-dialog
    header="{{ 'offer-letter.hireCandidate' | translate }}"
    [open]="openHireCandidateWarningModal"
    (closing)="openHireCandidateWarningModal = false"
>
    <p>{{ 'offer-letter.infoHireCandidate' | translate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="openHireCandidateWarningModal = false">{{
            'offer-letter.cancel' | translate
        }}</ui-button>
        <ui-button type="primary" (click)="sendToHireFlow(); openHireCandidateWarningModal = false">{{
            'offer-letter.hireNow' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<!-- Template -->
<div class="ui basic segment" [class.loading]="isLoading">
    <div class="app-grid max-width">
        <!-- Header -->
        <app-header [title]="'offer-letter.title' | translate: { name: candidate.legalFullName }" [back]="true">
            <div class="buttons">
                <ui-button
                    *ngIf="candidate.hiredAt"
                    class="padding-right-1"
                    type="primary"
                    [routerLink]="['/', 'employees', 'directory', candidate.employeeId, 'personal']"
                    >{{ 'offer-letter.viewEmployeeProfile' | translate }}</ui-button
                >

                <!-- Meatball menu -->
                <button class="material-meatball-menu-button meatball-icon-border" [matMenuTriggerFor]="menu">
                    <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                </button>
                <mat-menu #menu="matMenu" xPosition="before">
                    <button mat-menu-item *ngIf="showWithdrawOfferButton" (click)="openWithdrawOfferModal = true">
                        {{ 'offer-letter.withdraw' | translate }}
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="showCandidateDeclinedButton"
                        (click)="openCandidateDeclinedModal = true"
                    >
                        {{ 'offer-letter.candidateDeclined' | translate }}
                    </button>
                    <button
                        mat-menu-item
                        (click)="onRevert()"
                        *ngIf="showRevertButton"
                        [disabled]="signingTemplateIsDeleted"
                    >
                        {{
                            (latestOfferLetter.signedAt
                                ? 'offer-letter.revertToAccepted'
                                : 'offer-letter.revertToPending'
                            ) | translate
                        }}
                    </button>
                    <button mat-menu-item (click)="openDeleteCandidateModal = true">
                        {{ 'offer-letter.deleteCandidate' | translate }}
                    </button>
                </mat-menu>
            </div>
        </app-header>

        <ui-banner *ngIf="offerLetterHasCosigners && !candidate.hiredAt" variant="info" class="margin-bottom-4">
            <p>{{ 'offer-letter.infoCosignersBanner' | appTranslate }}</p>
        </ui-banner>

        <div class="columns-8">
            <!-- Candidate Information Card -->
            <ui-card>
                <app-segment-header title="{{ 'offer-letter.candidateInformation' | translate }}">
                    <div class="buttons">
                        <ui-button type="link" (click)="modifyNoteModal.open = true; setModifyNoteModalTitle()">{{
                            (candidate.note ? 'offer-letter.editNote' : 'offer-letter.addNote') | translate
                        }}</ui-button>
                    </div>
                </app-segment-header>

                <!-- First Name -->
                <div class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.firstName' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ candidate.legalFirstName }} </span>
                </div>

                <!-- Last Name -->
                <div class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.lastName' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ candidate.legalLastName }} </span>
                </div>

                <!-- Email -->
                <div class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.emailAddress' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ candidate.email }} </span>
                </div>

                <!-- ReportsTo -->
                <div class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.reportsTo' | translate }}:</label>
                    <span class="columns-9 small-columns-12">
                        {{ latestOfferLetter.reportsTo ? candidate.latestOfferLetter.reportsTo.fullName : '-' }}
                    </span>
                </div>

                <!-- Note -->
                <div class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.note' | translate }}:</label>
                    <span class="columns-9 small-columns-12 preserve-white-space"> {{ candidate.note || '-' }} </span>
                </div>
            </ui-card>

            <!-- Cosigners Card -->
            <ui-card *ngIf="offerLetterHasCosigners">
                <app-segment-header title="{{ 'offer-letter.cosigners' | translate }}"> </app-segment-header>
                <ng-container *ngFor="let cosigner of candidate.latestOfferLetter.cosigners">
                    <div class="app-grid margin-y-2">
                        <label class="columns-3 small-columns-12">{{
                            cosigner.name | appTranslateOptions: templateSlotNamesDisplayOptions
                        }}</label>
                        <span class="columns-9 small-columns-12">
                            {{ cosigner.employee.fullName }} <span>({{ cosigner.employee.job?.title }})</span>
                            <ui-badge *ngIf="!cosigner.isSigned()" class="margin-left-2" type="warning">{{
                                'offer-letter.notSigned' | translate
                            }}</ui-badge>
                            <ui-badge *ngIf="cosigner.isSigned()" class="margin-left-2" type="success">{{
                                'offer-letter.signed' | translate
                            }}</ui-badge>
                        </span>
                    </div>
                </ng-container>
            </ui-card>

            <!-- Current Offer Details Card -->
            <ui-card>
                <app-segment-header title="{{ 'offer-letter.currentOfferDetails' | translate }}">
                    <div *ngIf="showReviseButton" class="buttons">
                        <ui-button type="link" (click)="reviseOfferModal.open = true">{{
                            'offer-letter.reviseOffer' | translate
                        }}</ui-button>
                    </div>
                </app-segment-header>

                <!-- Offer Letter Template -->
                <div class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12"
                        >{{ 'offer-letter.offerLetterTemplate' | translate }}:</label
                    >
                    <span class="columns-9 small-columns-12">
                        {{ latestOfferLetter.signingTemplate?.document.name || '-' }}
                    </span>
                </div>

                <!-- Offer Expiration Date -->
                <div class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12"
                        >{{ 'offer-letter.offerExpirationDate' | translate }}:</label
                    >
                    <span class="columns-9 small-columns-12">
                        {{ latestOfferLetter.expiresOn ? (latestOfferLetter.expiresOn | appDate) : '-' }}
                    </span>
                </div>

                <!-- Position -->
                <div *ngIf="latestOfferLetter.position" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.position' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.position.title }} </span>
                </div>

                <!-- Department -->
                <div *ngIf="latestOfferLetter.department" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.department' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.department.name }} </span>
                </div>

                <!-- Location -->
                <div *ngIf="latestOfferLetter.location" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.location' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.location.name }} </span>
                </div>

                <!-- Start Date -->
                <div *ngIf="latestOfferLetter.firstDayOfWorkOn" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.startDate' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.firstDayOfWorkOn | appDate }} </span>
                </div>

                <!-- Employment Type -->
                <div *ngIf="latestOfferLetter.employmentType" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.employmentType' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.employmentType }} </span>
                </div>

                <!-- Compensation Frequency -->
                <div *ngIf="latestOfferLetter.compensationFrequency" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.compensationRate' | translate }}:</label>
                    <span class="columns-9 small-columns-12">
                        {{ latestOfferLetter.compensationFrequencyDisplayValue }}
                    </span>
                </div>

                <!-- Compensation Rate -->
                <div *ngIf="latestOfferLetter.compensationRate" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.compensationRate' | translate }}:</label>
                    <span class="columns-9 small-columns-12">
                        {{ latestOfferLetter.compensationRate | maybeCurrency }}
                    </span>
                </div>

                <!-- Stock Options -->
                <div *ngIf="latestOfferLetter.stockOptions" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.stockOptions' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.stockOptions }} </span>
                </div>

                <!-- Probation Period -->
                <div *ngIf="latestOfferLetter.probationPeriod" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.probation' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.probationPeriod }} </span>
                </div>

                <!-- Contract Term -->
                <div *ngIf="latestOfferLetter.contractTerm" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.contractTerm' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.contractTerm }} </span>
                </div>

                <!-- Hours Per Week -->
                <div *ngIf="latestOfferLetter.hoursPerWeek" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.hoursPerWeek' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.hoursPerWeek }} </span>
                </div>

                <!-- Contract End Date -->
                <div *ngIf="latestOfferLetter.contractEndsOn" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.contractEndDate' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.contractEndsOn | appDate }} </span>
                </div>

                <!-- Vacation Days -->
                <div *ngIf="latestOfferLetter.vacationDays" class="app-grid margin-y-2">
                    <label class="columns-3 small-columns-12">{{ 'offer-letter.vacationDays' | translate }}:</label>
                    <span class="columns-9 small-columns-12"> {{ latestOfferLetter.vacationDays }} </span>
                </div>
            </ui-card>

            <!-- Offer History Card -->
            <ui-card>
                <app-table
                    (menuItemSelected)="onTableMenuEvent($event)"
                    [table]="offerLetterTable"
                    [showSearch]="false"
                    [useStickyHeader]="false"
                    [title]="'offer-letter.offerHistory' | translate"
                    [embedded]="true"
                    [isSmall]="true"
                >
                    <app-empty-state [label]="'offer-letter.noPreviousLetters' | translate"></app-empty-state>
                </app-table>
            </ui-card>
        </div>

        <!-- Offer Progress -->
        <div class="columns-4">
            <ui-card>
                <h2>{{ 'offer-letter.offerProgress' | translate }}</h2>
                <ng-container *ngIf="offerLetterHasCosigners">
                    <h4 class="font-medium">{{ 'offer-letter.cosigners' | translate }}:</h4>
                    <ui-approval-flow
                        [approvalFlowSteps]="cosignerApprovalFlowSteps"
                        (onButtonClick)="onRemindIndividual($event)"
                    >
                    </ui-approval-flow>
                </ng-container>

                <h4 *ngIf="offerLetterHasCosigners" class="font-medium">{{ 'offer-letter.candidate' | translate }}:</h4>
                <ui-approval-flow [approvalFlowSteps]="candidateApprovalFlowSteps"></ui-approval-flow>

                <div *ngIf="showHireCandidateButton" class="buttons padding-top-2">
                    <ui-button type="primary" (click)="onHireCandidate()" [disabled]="!canHireCandidate">{{
                        'offer-letter.hireCandidate' | translate
                    }}</ui-button>
                </div>
            </ui-card>
        </div>
    </div>
</div>
